export default async function ({ store, redirect }) {
  if (!store.state.ctoUserAuthentication.profile) {
    await store.dispatch('ctoUserAuthentication/loadProfile')
    if (!store.state.ctoUserAuthentication.profile) {
      return redirect({ name: 'login' })
    }
  }
}
